var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var COCEventSearchView = require('../views/COCEventSearchView');
var GetAllEventLookups = require('../../common/services/GetAllEventLookups');
var Session = require('psa-core/Session');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  var searchLimit = Session.config.CM_ELASTICSEARCH_MAX_RESULTS || 1000;
  $.when(GetAllEventLookups())
    .done(function(lookups) {
      NavUtils.navigate('coc/dashboard/event-search');

      Scaffold.content.show(
        new COCEventSearchView({
          model: new Backbone.Model({
            eventTypes: lookups.eventTypes,
            programs: lookups.programs,
            searchLimit: searchLimit
          })
        })
      );

      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
